import Cookies from 'universal-cookie';
import { environment } from '../environment';
export const storePortalModeInCookie = (mode) => {
    const cookies = new Cookies();
    cookies.set('portal-mode', mode);
};
export const getPortalModeUrl = (defaultUrl) => {
    const cookies = new Cookies();
    return cookies.get('portal-mode')
        ? cookies.get('portal-mode') === 'manager'
            ? environment.managerFrontendUrl
            : environment.employeeFrontendUrl
        : defaultUrl;
};
